
  import { Injectable } from '@angular/core';
  import { CanActivate, Router } from '@angular/router';
  import { AuthenticationService } from './authentication.service';
  import { Observable } from 'rxjs';

  @Injectable()
  export class AuthGuard implements CanActivate {
      constructor(private authService: AuthenticationService, private router: Router) { }


      canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        const isLogged = this.authService.isLoggedIn();
        if (!isLogged) {
          this.router.navigate(['login']);
        }
        return isLogged;
    }
  }
